import React from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

try {
  const savedTheme = localStorage.getItem('kkumhyeonlabs:theme');
  const theme = savedTheme || 'naver';
  if (!savedTheme) {
    localStorage.setItem('kkumhyeonlabs:theme', theme);
  }
  if (theme && theme !== 'default') {
    document.documentElement.dataset.theme = theme;
  } else {
    delete document.documentElement.dataset.theme;
  }
} catch {
  // ignore
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
